<template>
  <div class="dispath">
    <el-form
      ref="form"
      class="dispath_form"
      :model="form"
      label-position="top"
      :rules="rules"
    >
      <div ref="insure">
        <titleBlock
          class="title_bar"
          title="司机人险投保规则"
        >
          <div class="text-wrapper">
            <span class="text1">司机人险</span>
            <span class="text2">
              开启后订单配送的个体司机将自动进行人险投保
            </span>
          </div>
          <el-switch
            v-model="form.DRIVER_INSURANCE.flag"
            class="marginBottom"
            active-color="#06B880"
            inactive-color="#D9DBDE"
          />
          <template v-if="form.DRIVER_INSURANCE.flag">
            <el-row>
              <el-col :span="6">
                <el-form-item label="默认投保档次：" prop="DRIVER_INSURANCE.defaultValue">
                  <el-select
                    v-model="form.DRIVER_INSURANCE.defaultValue"
                    filterable
                    placeholder="请选择投保档次"
                  >
                    <el-option
                      v-for="t in levelOptions"
                      :key="t.value"
                      :label="t.label"
                      :value="t.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="margin: 0 20px">
                <el-form-item prop="DRIVER_INSURANCE.force">
                  <template #label>
                    强制司机投保
                    <!--                    <el-tooltip placement="top">-->
                    <!--                      <div slot="content">-->
                    <!--                        开启后运输车辆将强制投保，关闭配置司机在运输时可以选择车辆不投保-->
                    <!--                      </div>-->
                    <!--                      <i class="el-icon-warning text2" />-->
                    <!--                    </el-tooltip>-->
                  </template>
                  <el-switch
                    v-model="form.DRIVER_INSURANCE.force"
                    active-color="#06B880"
                    inactive-color="#D9DBDE"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-for="(domain, index) in form.DRIVER_INSURANCE.rules"
              :key="domain.key"
              class="box-wrapper"
            >
              <el-col :span="6">
                <el-form-item
                  :prop="'DRIVER_INSURANCE.rules.' + index + '.projectId'"
                  label="运营项目"
                  :rules="{
                    required: true, message: '请选择', trigger: 'change'
                  }"
                >
                  <el-select
                    v-model="domain.projectId"
                    filterable
                    placeholder="请选择项目"
                    @change="(val)=>changeProject(val,index)"
                  >
                    <el-option
                      v-for="t in projectOptions"
                      :key="t.value"
                      :label="t.label"
                      :disabled="isDisabledProject(t.value)"
                      :value="t.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="margin:0 20px">
                <el-form-item
                  :prop="'DRIVER_INSURANCE.rules.' + index + '.value'"
                  label="投保档次"
                  :rules="{
                    required: true, message: '请选择', trigger: 'change'
                  }"
                >
                  <el-select
                    v-model="domain.value"
                    filterable
                    placeholder="请选择投保档次"
                  >
                    <el-option
                      v-for="t in levelOptions"
                      :key="t.value"
                      :label="t.label"
                      :value="t.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-button
                type="text"
                class="danger"
                @click="handleDeleteInsure(index)"
              >
                删除
              </el-button>
            </el-row>
            <div
              v-if="form.DRIVER_INSURANCE.rules.length<projectOptions.length"
              class="addOrCondition_btn flex flex-center"
              @click="handleAddInsure"
            >
              <span>
                <i class="el-icon-plus" />添加投保规则
              </span>
            </div>
          </template>
        </titleBlock>
        <titleBlock title="超时处理">
          <div class="flex align-center marginBottom">
            <el-switch
              v-model="form.DRIVER_DEAL_OVER_TIME.flag"
              active-color="#059E84"
              inactive-color="#D9DBDE"
            />
            <span class="switch_tips">开启时流程到达节点超时触发后将自动取消，关闭后不会自动取消。</span>
          </div>
          <div v-if="form.DRIVER_DEAL_OVER_TIME.flag" class="new-flex">
            <div class="second-title required">
              流程到达该节点
            </div>
            <el-form-item
              class="overTime_trigger"
              prop="DRIVER_DEAL_OVER_TIME_CONDITION.fieldName"
            >
              <div class="receiving_time flex align-center">
                <div class="flex align-center">
                  <el-select
                    v-model="form.DRIVER_DEAL_OVER_TIME_CONDITION.fieldName"
                    placeholder="请选择"
                    class="receivingTimeType"
                  >
                    <el-option
                      v-for="item in receivingTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <el-select v-model="form.DRIVER_DEAL_OVER_TIME_CONDITION.action" class="receivingTimeTypeUnit">
                    <el-option
                      v-for="item in receivingStsgeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="DRIVER_DEAL_OVER_TIME_CONDITION.num">
              <div class="time_input flex align-center">
                <el-input v-model="form.DRIVER_DEAL_OVER_TIME_CONDITION.num" placeholder="请输入" />
                <el-select v-model="form.DRIVER_DEAL_OVER_TIME_CONDITION.unit">
                  <el-option
                    v-for="item in timeUnit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span v-if="form.overTimeTrigger!==OVERTIME_TYPE.BASIS_TABLE_FIELD" class="basis">后</span>
              </div>
            </el-form-item>
          </div>
        </titleBlock>
      </div>
    </el-form>
  </div>
</template>

<script>
import { processingSelectData } from '@/utils/index';
import { getProjectList } from '@/api/user';
import titleBlock from '../assembly/titleBlock.vue';
import {
  timeReg, RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE, TIME_UNIT, OVERTIME_TYPE,
} from './const';

export default {
  name: 'DriverReceiveOrder',
  components: {
    titleBlock,
  },
  props: {
    customField: {
      type: Object,
      default: () => { },
    },
    customerCode: {
      type: String,
      default: null,
    },
    form: {
      type: Object,
      default: () => {},
    },
    parentProcessName: {
      type: String,
      default: '',
    },
    parentProcessCode: {
      type: String,
      default: '',
    },
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if (!timeReg.test(Number(value))) {
        callback('请输入正确的时间');
      }
      callback();
    };
    return {
      projectOptions: [],
      OVERTIME_TYPE,
      levelOptions: [
        { label: '40万保额', value: 40 },
        { label: '60万保额', value: 60 },
      ],
      // chooseProject: {},
      // chooseLevel: {},
      rules: {
        'DRIVER_INSURANCE.defaultValue': [
          { required: true, message: '请选择默认投保档次', trigger: 'change' },
        ],
        'DRIVER_INSURANCE.force': [
          { required: true, message: '请选择强制司机投保', trigger: 'change' },
        ],
        'DRIVER_DEAL_OVER_TIME.flag': [
          { required: true, message: '请选择接单设置', trigger: 'change' },
        ],
        'DRIVER_DEAL_OVER_TIME_CONDITION.fieldName': [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        'DRIVER_DEAL_OVER_TIME_CONDITION.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
  },
  watch: {
    customerCode: {
      handler(val) {
        if (val) {
          this.getProjectListFn();
        }
      },
      immediate: true,
    },
    // 'form.INSURANCE.rules': {
    //   handler(val) {
    //     if (!val || !val.length) {
    //       this.chooseInfo = {};
    //       return;
    //     }
    //     const chooseProject = {};
    //     const chooseCarType = {};
    //     val.forEach((item) => {
    //       if (item.projectId && item.carType) {
    //         const project = chooseProject[item.projectId];
    //         const carType = chooseCarType[item.carType];
    //         chooseProject[item.projectId] = project ? [...project, item.carType] : [item.carType];
    //         chooseCarType[item.carType] = carType ? [...carType, item.projectId] : [item.projectId];
    //       }
    //     });
    //     this.chooseProject = chooseProject;
    //     this.chooseCarType = chooseCarType;
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    async getProjectListFn() {
      const data = await getProjectList({
        customerCodes: [this.customerCode],
        status: 'ENABLE',
      });
      this.projectOptions = data.length > 0 ? data.map((t) => ({
        label: t.projectName,
        value: t.id,
      })) : [];
    },
    changeProject(val, index) {
      const tt = this.form.DRIVER_INSURANCE.rules[index];
      const proItem = this.projectOptions.find((t) => t.value === val);
      this.form.DRIVER_INSURANCE.rules.splice(index, 1, {
        ...tt,
        projectName: proItem.label,
      });
    },
    handleDeleteInsure(index) {
      // 删除投保规则
      const list = this.form.DRIVER_INSURANCE.rules;
      list.splice(index, 1);
      this.$set(this.form.DRIVER_INSURANCE, 'rules', list);
    },
    handleAddInsure() {
      // 添加投保规则
      const list = this.form.DRIVER_INSURANCE.rules;
      list.push({
        projectId: '',
        projectName: '',
        value: '',
      });
      this.$set(this.form.DRIVER_INSURANCE, 'rules', list);
    },
    async valiForm() {
      await this.$refs.form.validate();
      let data = Object.keys(JSON.parse(JSON.stringify(this.form)));
      if (!this.form.DRIVER_DEAL_OVER_TIME.flag) {
        data = data.filter((item) => item !== 'DRIVER_DEAL_OVER_TIME_CONDITION');
      }
      const res = data.map((item) => ({
        ruleCode: item,
        ruleValue: item !== 'DRIVER_INSURANCE' ? this.form[item] : {
          ...this.form.DRIVER_INSURANCE,
          force: this.form.DRIVER_INSURANCE.flag ? this.form.DRIVER_INSURANCE.force : false,
          defaultValue: this.form.DRIVER_INSURANCE.flag ? this.form.DRIVER_INSURANCE.defaultValue : '',
          rules: this.form.DRIVER_INSURANCE.rules && this.form.DRIVER_INSURANCE.rules.length > 0 ? this.form.DRIVER_INSURANCE.rules.map((m) => ({
            ...m,
          })) : [],
        },
      }));
      return {
        form: this.form,
        res,
      };
    },
    isDisabledProject(projectId) {
      const projectIds = this.form.DRIVER_INSURANCE.rules.map((item) => item.projectId).filter((item) => item);
      return projectIds.includes(projectId);
    },
  },
};
</script>

<style lang="scss" scoped>
.dispath {
  padding: 24px 24px 40px 24px;
  ::v-deep .el-select{
    width: 100%;
  }
  .text-wrapper {
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
    }
  }
  .text2{
    font-size: 13px;
    color:#808792;
    margin-left:8px;
  }
  ::v-deep .el-radio.is-checked {
    .text2 {
      color:#06B880;
    }
  }
  .addOrCondition_btn{
    cursor: pointer;
    height: 38px;
    border: 1px dashed #B3B7BE;
    font-size: 14px;
    margin-bottom: 24px;
    .el-icon-plus{
      margin-right: 10px;
    }
    &:hover{
      border-color: #51CDA6;
      color: #51CDA6;
    }
    &:focus{
      border-color: #059366;
      color: #059366;
    }
  }
  .danger{
    color:red;
    position: relative;
    top:30px;
  }
}
.new-flex {
  display:flex;
  flex-wrap:wrap;
  .second-title{
    color:#404B5C;
    margin-bottom:8px;
    width:100%;
  }
  ::v-deep .el-form-item{
    margin-right:16px;
    .el-select{
      margin-right:8px;
    }
    .el-input{
      margin-right:8px;
    }
  }
}
.required:before{
  content:'*';
  color:red;
}
.marginBottom{
  margin:8px 0 24px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
</style>
